// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Cm","categoryName":"Dm","categoryImage":"Em","categoryContent":"Fm","bottomAligned":"Gm"};